<div class="pageContainer refreshed-ui">
    <div class="spd-wrapper">
        <div class="sp-breadcrumb-nav-bar">
            <a data-id="solution-participation-details" [routerLink]="['/solution-participation-details']" [queryParams]="{tab: 'solution-group-view'}" class="link-blue">
                Solution Participation - Solution Group View
            </a>
            <div class="chevron"><img src="assets/chevron-right.svg" alt="chevron-right" /></div>
            <a data-id="solution-participation-groupBy" class="last-breadcrumb link-blue">
                Location Details
            </a>
        </div>

        <!-- Tabs section -->
        <section class="tabs-container">
            <div class="sg-tab hover-pointer" data-id="usage-locations-tab" [ngClass]="{'selectedTab': tabSelected === 'by-usage'}" (click)="changeTab('by-usage')">
                Usage Locations ({{usageLocationsCount}})
            </div>
            <div class="sg-tab hover-pointer" data-id="nonusage-locations-tab"  [ngClass]="{'selectedTab': tabSelected === 'by-nonusage'}" (click)="changeTab('by-nonusage')">
                Non-Usage Locations ({{nonUsageLocationsCount}})
            </div>
        </section>

        <div class="search-block">
            <div class="search-box" id="search-box">
                <img src="assets/gray-search-icon.png" class="search-icon" alt="search-icon" (click)="searchLocation()">
                <input
                    [(ngModel)]="searchTerm"
                    (ngModelChange)="onSearchInputChangeEvent()"
                    (focus)="onSearchFocus()"
                    (blur)="onSearchBlur()"
                    (keyup.enter)="searchLocation()"
                    placeholder="Search Locations"
                    id="userInput"
                >
                <img class="clear-icon" src="assets/clear-icon.svg" alt="clear-icon" class="clear-search" (click)="clear()"/>
            </div>
            <mat-chip-listbox id="selected-filter-list">
                <mat-chip-option
                        *ngFor="let filterChip of getAdvancedFilterChips()"
                        class="advanced-filters-chip-list"
                        disabled>
                        {{ filterChip }}
                </mat-chip-option>
                </mat-chip-listbox>
            <div class="exporttable-btn"  (click)="exportAllToExcel()">
                <div class="export-icon">
                 <span *ngIf="!isDownloadingFile">
                    <img src="assets/export-table-icon.svg" alt="export-table-icon" />
                </span>
                <span *ngIf="isDownloadingFile">
                    <span class="loader-sm"></span>
                </span>
                </div>
                <span>Export Table</span>
            </div>

        </div>

        <div class="search-pagination-row neptune-advanced-filters">
            <div id="sol-loc-toggle-pagination" class="sol-loc-toggle-pagination" *ngIf="!displayLoaderForFilterData">
                <advanced-filters
                    [advancedFilterData]="advancedFilterData"
                    [excludeKeys]="excludeKeys"
                    [pageScope] = "'Solution participation Location Details'"
                    [selectedAdvancedFilters] = "viewSelectedAdvancedFilters"
                    [filterGroupings]="filterGroupings"
                    (selectedFilters) = "onSelectedFiltersChange($event)"
                    [(toggleBody)]="toggleAdvancedFilterSelection"
                    [useRefreshedUi]="true"
                    >
                </advanced-filters>
                <advanced-filters-selection
                    [advancedFilterData]="advancedFilterData"
                    [excludeKeys]="excludeKeys"
                    [pageScope]="'Solution participation Location Details'"
                    [selectedAdvancedFilters]="viewSelectedAdvancedFilters"
                    [filterGroupings]="filterGroupings"
                    (selectedFilters)="onSelectedFiltersChange($event)"
                    [(toggleBody)]="toggleAdvancedFilterSelection"
                >
                </advanced-filters-selection>
            </div>
            <mat-paginator #paginator [pageSize]="10" [pageSizeOptions]="[5, 10, 20, 50]" [length]="totalRecords"
            (page)="onPageChange($event)" aria-label="Select page"></mat-paginator>
        </div>

        <!-- Locations Details Table -->
        <section class="location-details-table" *ngIf="!isLoading; else loader" id="locations-details-table">
            <!-- Table header section -->
            <div class="header-box">
                <div class="location common-p">
                    Location
                    <span class="sort-arrow"  data-id="sort-arrow-location" (click)="toggleSortDirection('location')">
                        <img class="sort-arrow-img" [ngClass]="{'up': sortDirections['location'] == 'asc', 'down': sortDirections['location'] == 'desc' }" src="assets/blue-arrow.svg" alt="sort-arrow" />
                    </span>
                </div>
                <div class="accountNumber common-p">Account Number</div>
                <div class="product common-p">Product</div>
                <div class="sales common-p">
                    Product Sales Summary
                    <span class="sort-arrow" data-id="sort-arrow-sales" (click)="toggleSortDirection('sales')">
                        <img class="sort-arrow-img" [ngClass]="{'up': sortDirections['sales'] == 'asc', 'down': sortDirections['sales'] == 'desc' }" src="assets/blue-arrow.svg" alt="sort-arrow" />
                    </span>
                </div>
                <div class="cases common-p">
                    Cases
                    <span class="sort-arrow" data-id="sort-arrow-cases"  (click)="toggleSortDirection('cases')">
                        <img class="sort-arrow-img" [ngClass]="{'up': sortDirections['cases'] == 'asc', 'down': sortDirections['cases'] == 'desc' }" src="assets/blue-arrow.svg" alt="sort-arrow" />
                    </span>
                </div>
                <div class="exportall-checkbox common-p">
                    <mat-checkbox color="primary" (change)="selectAllRows()" [checked]="allRowsSelected">Export All</mat-checkbox>
                </div>
            </div>

            <ng-container *ngIf="groupedData?.locations?.length; else noData">
                <ng-container *ngFor="let location of groupedDataPaginated; let i = index;">
                    <div class="locations-table-row"  [id]="'location-table-row-' + i"
                        [ngClass]="{'summary-row': location.productCount || location.accountCount > 1}"
                        (click)="locationDrillClicked(location, $event,i)">
                        <!-- Location block -->
                        <div class="location-block p-20">
                            <div class="text-700">{{location?.mdmSiteId}} - {{location?.siteName! | capitalize}},</div>
                            <div >{{location?.address}},</div>
                            <div>
                                <span>{{location?.city! | capitalize}},</span>
                                <ng-container *ngIf="location?.state">
                                    {{location?.state}},
                                </ng-container>
                            </div>
                            <div>{{location?.country}} - {{location?.postalAddress}}</div>
                        </div>

                        <!-- Account Number, Product Name, Sales and Cases Block -->
                        <ng-container [ngSwitch]="location?.productCount === 0 ? 'zero' : location?.productCount === 1 && location?.accountCount === 1 ? 'single' : 'multiple'">
                            <!-- Products Length == 0 -->
                            <ng-container *ngSwitchCase="'zero'">
                                <ng-container *ngIf="location?.isNonUsageLocations">
                                    <div class="account-block p-20">{{location.accountNumber}}</div>
                                    <div class="product-block p-20">N/A</div>
                                    <div class="sales-block p-20">N/A</div>
                                    <div class="cases-block p-20">N/A</div>
                                </ng-container>
                            </ng-container>

                            <!-- Products Length == 1 -->
                            <ng-container *ngSwitchCase="'single'">
                                <ng-container *ngIf="!location?.isNonUsageLocations">
                                    <div class="account-block p-20">
                                        {{location.accountNumber}}
                                    </div>
                                    <div class="product-block p-20">
                                        <p class="product-name">{{location.productInfo[0].productName}}</p>
                                        <p class="product-code">SKU - {{location.productInfo[0].productCode}}</p>
                                    </div>
                                    <div class="sales-block p-20">
                                        <p class="sales-amount">{{currencyCode | currencySymbol}}{{location.totalSales.value | number:'1.0-0'}}</p>
                                    </div>
                                    <div class="cases-block p-20">
                                        <p class="cases-amount">{{location.totalCases | number}}</p>
                                    </div>
                              </ng-container>
                            </ng-container>

                            <!-- Products Length > 1 -->
                            <ng-container *ngSwitchDefault>
                                <div class="account-block p-20">
                                    <div class="account-box">
                                        <div class="count"> {{location?.accountCount}} </div>
                                        <div class="sub-text">Accounts</div>
                                    </div>
                                </div>
                                <div class="product-block p-20">
                                    <div class="products-box">
                                        <div class="count">{{location?.productCount}}</div>
                                        <div class="sub-text">Products</div>
                                    </div>
                                </div>
                                <div class="sales-block p-20">
                                    <p class="total-sales total"><span class="text-gray">Total Sales</span> - {{currencyCode | currencySymbol}}{{location.totalSales.value | number:'1.0-0'}}</p>
                                </div>
                                <div class="cases-block p-20">
                                    <p class="total-cases total"><span class="text-gray">Total Cases</span> - {{location.totalCases | number}}</p>
                                </div>
                            </ng-container>
                        </ng-container>

                        <div class="export-block p-20">
                            <div class="export-checkbox">
                                <mat-checkbox color="primary" [checked]="getCurrentRowSelectionByUsageOrNonUsage()[(paginator.pageIndex * paginator.pageSize) + i]" #checkBox (change)="onCheckboxChange(checkBox,location, i)">Export</mat-checkbox>
                            </div>
                        </div>

                    </div>
                </ng-container>
            </ng-container>

            <!-- Display 'No Data' when there are no locations on load -->
            <ng-template #noData>
                <div *ngIf="!locationDataNotFound" class="Loader">
                    No Data
                </div>
            </ng-template>

            <!-- Display 'Location not found' when search results are empty -->
            <ng-template [ngIf]="(locationDataNotFound && !isLoading)">
                <div class="not-found">
                    Location not found.
                </div>
            </ng-template>
        </section>

        <ng-template #loader>
            <div class="Loader">
                Loading...
                <loader></loader>
            </div>
        </ng-template>
    </div>
</div>
